<template>
  <div class="d-inline-flex">
    <v-menu
      v-model="visible"
      :close-on-content-click="false"
      :min-width="$vuetify.breakpoint.xsOnly ? 280 : 500"
      max-width="500"
      offset-y
    >
      <template #activator="{on}">
        <div
          class="my-1"
          v-on="on"
        >
          <v-btn
            v-if="value"
            class="px-1"
            color="info"
            depressed
            small
          >
            <v-icon
              class="ml-0"
              left
            >
              mdi-playlist-edit
            </v-icon>

            {{ $tc('Message.Title', 1) }}

            <template v-for="lang in selectedLanguages">
              <div
                v-if="type === 'email' ? !value.subject[lang.Code] || !value.body[lang.Code] : !value[lang.Code]"
                :key="lang.Code"
                class="mx-1 d-inline-block"
              >
                <v-badge
                  :value="type === 'email' ? !value.subject[lang.Code] || !value.body[lang.Code] : !value[lang.Code]"
                  color="orange"
                  overlap
                  right
                >
                  <template #badge>
                    <v-icon
                      dark
                      small
                    >
                      priority_high
                    </v-icon>
                  </template>

                  <v-avatar size="20">
                    <img
                      :class="[{'grayscale opacity': type === 'email' ? !value.subject[lang.Code] || !value.body[lang.Code] : !value[lang.Code]}]"
                      :src="lang.ImageUrl"
                    >
                  </v-avatar>
                </v-badge>
              </div>
            </template>
          </v-btn>
        </div>
      </template>

      <v-card v-if="editVal">
        <v-card-text>
          <v-form
            ref="editForm"
            v-model="formValid"
            @submit.prevent
          >
            <template v-if="type === 'email'">
              <div class="text-body-1 font-weight-bold">
                Subject
              </div>
              <template v-for="lang in selectedLanguages">
                <v-text-field
                  :key="`subject-${lang.Code}`"
                  v-model="editVal.subject[lang.Code]"
                  :rules="rules"
                  class="my-1"
                  clearable
                  dense
                  hide-details
                  outlined
                  placeholder="Μήνυμα"
                  required
                  single-line
                >
                  <template #prepend-inner>
                    <v-avatar
                      v-if="lang.ImageUrl"
                      class="mr-1 rounded"
                      size="26"
                      tile
                    >
                      <v-img :src="lang.ImageUrl" />
                    </v-avatar>
                  </template>
                </v-text-field>
              </template>

              <div class="mt-4 text-body-1 font-weight-bold">
                Body
              </div>
              <template v-for="lang in selectedLanguages">
                <v-text-field
                  :key="`body-${lang.Code}`"
                  v-model="editVal.body[lang.Code]"
                  :rules="rules"
                  class="my-1"
                  clearable
                  dense
                  hide-details
                  outlined
                  placeholder="Μήνυμα"
                  required
                  single-line
                >
                  <template #prepend-inner>
                    <v-avatar
                      v-if="lang.ImageUrl"
                      class="mr-1 rounded"
                      size="26"
                      tile
                    >
                      <v-img :src="lang.ImageUrl" />
                    </v-avatar>
                  </template>
                </v-text-field>
              </template>
            </template>

            <template v-else>
              <template v-for="lang in selectedLanguages">
                <v-text-field
                  :key="lang.Code"
                  v-model="editVal[lang.Code]"
                  :rules="rules"
                  class="my-1"
                  clearable
                  dense
                  hide-details
                  outlined
                  placeholder="Μήνυμα"
                  required
                  single-line
                >
                  <template #prepend-inner>
                    <v-avatar
                      v-if="lang.ImageUrl"
                      class="mr-1 rounded"
                      size="26"
                      tile
                    >
                      <v-img :src="lang.ImageUrl" />
                    </v-avatar>
                  </template>
                </v-text-field>
              </template>
            </template>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions
          :class="[{'text-center': $vuetify.breakpoint.xsOnly}]"
          :style="$vuetify.breakpoint.xsOnly ? 'display: block;' : ''"
          class=""
        >
          <v-spacer class="hidden-xs-only" />

          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            small
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>

          <v-btn
            class="green white--text elevation-0"
            small
            @click="onSaveButtonClick"
          >
            {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

import AppData from '@/mixins/appdata'
import {clone} from '@/lib/helper/helper.js'

export default {
  name      : 'NotificationEditableLangValue',
  components: {},
  directives: {},
  mixins    : [AppData],
  props     : {
    index: {
      type    : Number,
      required: true
    },
    value: {
      type    : Object,
      required: true
    },
    type: {
      type    : String,
      required: true
    },
    rules: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {
      visible  : false,
      formValid: false,
      editVal  : null
    }
  },
  computed: {},
  watch   : {
    visible(newVal) {
      if (newVal) {
        this.editVal = clone(this.value)
      }
    }
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onSaveButtonClick() {
      this.$refs.editForm.validate()

      if (this.formValid) {
        this.$emit('save', {
          Index: this.index,
          Type : this.type,
          Value: this.editVal
        })

        this.visible = false
      }
    },

    onCancelButtonClick() {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
